import { graphqlOperationWithTokenRefresh } from './graphqlOperation';
import { GetMasterInfoQuery, QueryOutputType } from '../type/QueryType';
import { coexistenceGetType } from '../const/commonConst';
import { GetMasterInfoInput } from '../../API';

// マスタ情報取得用のクエリ
const queryForCurrentCarPlace = /* GraphQL */ `
	query GetMasterInfo($input: GetMasterInfoInput!) {
		getOffsegOrganizationInfo(input: $input) {
			responseType
			message
			organizationInfoList {
				organizationId
				organizationName
			}
		}
		getOffsegCarInfo(input: $input) {
			responseType
			message
			carInfoList {
				carId
				carCode
				numberPlate
				organizationName
			}
		}
		getOffsegDriverInfo(input: $input) {
			responseType
			message
			driverInfoList {
				driverId
				driverName
			}
		}
		getG500LiteOrganizationInfo(input: $input) {
			responseType
			message
			organizationInfoList {
				organizationId
				organizationName
			}
		}
		getG500LiteCarInfo(input: $input) {
			responseType
			message
			carInfoList {
				carId
				carCode
				numberPlate
				organizationName
			}
		}
	}
`;

const queryForCarUseResult = /* GraphQL */ `
	query GetMasterInfo($input: GetMasterInfoInput!) {
		getOffsegOrganizationInfo(input: $input) {
			responseType
			message
			organizationInfoList {
				organizationId
				organizationName
			}
		}
		getOffsegCarInfo(input: $input) {
			responseType
			message
			carInfoList {
				carId
				carCode
				numberPlate
				organizationName
			}
		}
		getOffsegDriverInfo(input: $input) {
			responseType
			message
			driverInfoList {
				driverId
				driverName
			}
		}
		getG500LiteOrganizationInfo(input: $input) {
			responseType
			message
			organizationInfoList {
				organizationId
				organizationName
			}
		}
		getG500LiteCarInfo(input: $input) {
			responseType
			message
			carInfoList {
				carId
				carCode
				numberPlate
				organizationName
			}
		}
		getG500LiteDriverInfo(input: $input) {
			responseType
			message
			driverInfoList {
				driverId
				driverName
			}
		}
	}
`;

const queryForEventVideo = /* GraphQL */ `
	query GetMasterInfo($input: GetMasterInfoInput!) {
		getOffsegOrganizationInfo(input: $input) {
			responseType
			message
			organizationInfoList {
				organizationId
				organizationName
			}
		}
		getOffsegDriverInfo(input: $input) {
			responseType
			message
			driverInfoList {
				driverId
				driverName
			}
		}
		getG500LiteOrganizationInfo(input: $input) {
			responseType
			message
			organizationInfoList {
				organizationId
				organizationName
			}
		}
		getG500LiteDriverInfo(input: $input) {
			responseType
			message
			driverInfoList {
				driverId
				driverName
			}
		}
	}
`;

/**
 * マスタ情報取得APIを呼び出す
 */
export const queryGetMasterInfo = async (
	getType: (typeof coexistenceGetType)[keyof typeof coexistenceGetType],
	getMasterInfoInput: GetMasterInfoInput,
	authorizationToken: string,
): Promise<QueryOutputType<GetMasterInfoQuery>> => {
	const query =
		getType === coexistenceGetType.currentCarPlace
			? queryForCurrentCarPlace
			: getType === coexistenceGetType.carUseResult
			? queryForCarUseResult
			: queryForEventVideo;

	const apiResponse = await graphqlOperationWithTokenRefresh<GetMasterInfoQuery>(query, { input: getMasterInfoInput }, authorizationToken);
	console.log(apiResponse);

	return apiResponse;
};
